import axios from 'axios';

// Leer variable de entorno con fallback
// IMPORTANTE: Esta variable debe estar configurada en el build
let PYTHON_API_BASE_URL = process.env.REACT_APP_PYTHON_API_URL || 'http://localhost:8003';

// Log inmediato para debug
console.log('🚀 INICIO pythonBaseApi.js');
console.log('   process.env.REACT_APP_PYTHON_API_URL:', process.env.REACT_APP_PYTHON_API_URL);
console.log('   PYTHON_API_BASE_URL (inicial):', PYTHON_API_BASE_URL);

// CORRECCIÓN AUTOMÁTICA: Si detecta el dominio incorrecto, corregirlo
if (PYTHON_API_BASE_URL.includes('sgc-campamento-backend-staging.devjal.tech')) {
  console.warn('⚠️  Detectado dominio incorrecto, corrigiendo automáticamente...');
  PYTHON_API_BASE_URL = PYTHON_API_BASE_URL.replace(
    'sgc-campamento-backend-staging.devjal.tech',
    'sgc-staging.devjal.tech'
  );
  console.warn('✅ Corregido a:', PYTHON_API_BASE_URL);
  console.warn('💡 Actualiza REACT_APP_PYTHON_API_URL en tu .env a: https://sgc-staging.devjal.tech');
}

// Usar /api-campamento siempre (tanto en local como en producción)
// El backend Python ahora usa prefijo /api-campamento/ para todas las rutas
const API_PATH = '/api-campamento';

// Construir baseURL completo
// Asegurar que no haya doble barra: remover barra final de BASE_URL si existe, y agregar API_PATH
const cleanBaseUrl = PYTHON_API_BASE_URL.replace(/\/$/, ''); // Remover barra final si existe
const FULL_BASE_URL = `${cleanBaseUrl}${API_PATH}`;

// Debug detallado
console.log('🔍 DEBUG - Construcción de URL Python:');
console.log('   PYTHON_API_BASE_URL (original):', process.env.REACT_APP_PYTHON_API_URL || 'fallback');
console.log('   PYTHON_API_BASE_URL (procesado):', PYTHON_API_BASE_URL);
console.log('   API_PATH:', API_PATH);
console.log('   cleanBaseUrl:', cleanBaseUrl);
console.log('   FULL_BASE_URL (final):', FULL_BASE_URL);

if (process.env.REACT_APP_PYTHON_API_URL) {
  console.log('✅ PYTHON_API_BASE_URL desde .env:', process.env.REACT_APP_PYTHON_API_URL);
  console.log(`✅ Usando ruta: ${API_PATH} (siempre /api-campamento para Python)`);
} else {
  console.warn('⚠️  REACT_APP_PYTHON_API_URL no encontrada, usando fallback:', PYTHON_API_BASE_URL);
  console.warn('💡 Asegúrate de tener REACT_APP_PYTHON_API_URL en tu archivo .env y reinicia el servidor');
  console.log(`✅ Usando ruta: ${API_PATH} (siempre /api-campamento para Python)`);
}

// Validar que FULL_BASE_URL esté correctamente construida
if (!FULL_BASE_URL || (!FULL_BASE_URL.includes('/api-campamento') && !FULL_BASE_URL.includes('/api'))) {
  console.error('❌ ERROR: FULL_BASE_URL no contiene /api-campamento o /api');
  console.error('   FULL_BASE_URL:', FULL_BASE_URL);
  throw new Error('FULL_BASE_URL no está correctamente configurada');
}

// Cliente base configurado para Python FastAPI
// Simple y directo: configurar baseURL y dejar que Axios lo maneje
const pythonApiClient = axios.create({
  baseURL: FULL_BASE_URL,
  timeout: 300000, // 5 minutos
});

console.log('🌐 Python Axios baseURL configurado como:', pythonApiClient.defaults.baseURL || '(vacío - las peticiones fallarán)');
if (FULL_BASE_URL) {
  console.log('🌐 URL completa de ejemplo:', `${FULL_BASE_URL}/seguridad/auth/login`);
  console.log('🌐 Verificar que baseURL termine con /api-campamento:', pythonApiClient.defaults.baseURL.endsWith('/api-campamento'));
} else {
  console.warn('⚠️  baseURL está vacío. Las peticiones se harán al origen actual (frontend) en lugar del backend Python.');
}

// Interceptor simple: solo agregar headers, dejar que Axios maneje las URLs normalmente
// Funciona igual en local y producción - solo asegurar que baseURL esté correcto
pythonApiClient.interceptors.request.use(
  (config) => {
    // VALIDACIÓN CRÍTICA: Verificar y corregir baseURL si es necesario
    // Siempre debe incluir /api-campamento (tanto en local como en producción)
    if (!config.baseURL || !config.baseURL.includes('/api-campamento')) {
      console.error('❌ ERROR: baseURL no incluye /api-campamento');
      console.error('   baseURL recibido:', config.baseURL);
      console.error('   FULL_BASE_URL esperado:', FULL_BASE_URL);
      console.error('   Corrigiendo...');
      config.baseURL = FULL_BASE_URL;
      console.warn('✅ baseURL corregido a:', config.baseURL);
    }
    
    // También verificar pythonApiClient.defaults.baseURL
    if (pythonApiClient.defaults.baseURL !== FULL_BASE_URL) {
      console.error('❌ ERROR: pythonApiClient.defaults.baseURL incorrecto');
      console.error('   defaults.baseURL:', pythonApiClient.defaults.baseURL);
      console.error('   FULL_BASE_URL esperado:', FULL_BASE_URL);
      pythonApiClient.defaults.baseURL = FULL_BASE_URL;
      console.warn('✅ defaults.baseURL corregido a:', pythonApiClient.defaults.baseURL);
    }
    
    // Agregar token si existe
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Agregar proyecto_id desde localStorage en header (no enviar -1 = contexto corporativo)
    try {
      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || 'null');
      const pid = selectedProject?.id;
      if (pid != null && pid !== '' && Number(pid) > 0) {
        config.headers['X-Proyecto-ID'] = String(pid);
      }
    } catch (e) {
      // Si hay error al leer localStorage, continuar sin el header
    }
    
    config.metadata = { startTime: performance.now() };
    
    // Debug: Mostrar la URL completa que se está construyendo
    const fullUrl = config.baseURL && config.url
      ? `${config.baseURL.replace(/\/$/, '')}${config.url.startsWith('/') ? config.url : `/${config.url}`}`
      : config.url || config.baseURL || 'URL no disponible';
    
    // VALIDACIÓN FINAL: Verificar que la URL completa incluya /api-campamento
    if (!fullUrl.includes('/api-campamento')) {
      console.error('❌ ERROR CRÍTICO: URL completa no incluye /api-campamento');
      console.error('   fullUrl calculada:', fullUrl);
      console.error('   config.baseURL:', config.baseURL);
      console.error('   config.url:', config.url);
      console.error('   defaults.baseURL:', pythonApiClient.defaults.baseURL);
    }
    
    console.log(`🔵 PYTHON REQUEST: ${config.method?.toUpperCase()} ${fullUrl}`, {
      baseURL: config.baseURL,
      defaultsBaseURL: pythonApiClient.defaults.baseURL,
      url: config.url,
      fullUrl: fullUrl,
      includesApiCampamento: fullUrl.includes('/api-campamento'),
      // Debug adicional para turnos-cabecera
      isTurnosCabecera: config.url?.includes('turnos-cabecera'),
      configUrl: config.url,
      configBaseURL: config.baseURL
    });
    
    // DEBUG ESPECÍFICO: Si es turnos-cabecera, agregar log adicional
    if (config.url?.includes('turnos-cabecera')) {
      console.log('🔍 DEBUG TURNOS-CABECERA:', {
        'config.url original': config.url,
        'config.baseURL': config.baseURL,
        'defaults.baseURL': pythonApiClient.defaults.baseURL,
        'fullUrl calculada': fullUrl,
        'URL debería incluir /api-campamento': fullUrl.includes('/api-campamento'),
        'Método': config.method
      });
    }
    
    return config;
  },
  (error) => {
    console.error('❌ PYTHON INTERCEPTOR REQUEST ERROR:', error);
    return Promise.reject(error);
  }
);

// Interceptor para manejo de errores
pythonApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const duration = error.config?.metadata ? performance.now() - error.config.metadata.startTime : 0;
    const status = error.response?.status;
    
    // DEBUG CRÍTICO: Si es turnos-cabecera y hay error, mostrar información detallada
    if (error.config?.url?.includes('turnos-cabecera')) {
      console.error('🔴 ERROR TURNOS-CABECERA - Información detallada:', {
        'error.config.url': error.config?.url,
        'error.config.baseURL': error.config?.baseURL,
        'error.request.responseURL': error.request?.responseURL,
        'error.request.url': error.request?.url,
        'error.response?.config?.url': error.response?.config?.url,
        'error.response?.config?.baseURL': error.response?.config?.baseURL,
        'status': status,
        'method': error.config?.method
      });
      
      // Verificar si la URL real incluye /api en lugar de /api-campamento
      const actualUrl = error.request?.responseURL || error.request?.url || error.config?.url;
      if (actualUrl && actualUrl.includes('/api/procesos/alimentacion/turnos-cabecera')) {
        console.error('❌ PROBLEMA DETECTADO: La URL real contiene /api en lugar de /api-campamento');
        console.error('   URL esperada (con /api-campamento):', error.config?.baseURL + error.config?.url);
        console.error('   URL real (con /api):', actualUrl);
        console.error('   Esto indica que algo está modificando la URL después del interceptor');
      }
    }
    
    // Para errores 422 (validación), solo loguear como info (no es un error crítico)
    if (status === 422) {
      console.log(`ℹ️ PYTHON VALIDATION: ${error.config?.method?.toUpperCase()} ${error.config?.url} - Duración: ${duration.toFixed(2)}ms - Status: ${status}`);
      return Promise.reject(error);
    }
    
    // Para otros errores, mostrar como error
    console.error(`❌ PYTHON INTERCEPTOR ERROR: ${error.config?.method?.toUpperCase()} ${error.config?.url} - Duración: ${duration.toFixed(2)}ms - Error:`, error.message);
    
    if (status === 401) {
      localStorage.removeItem('token');
      // No redirigir automáticamente, dejar que el componente maneje el error
    }

    if (status >= 500) {
      console.error('Error del servidor Python. Intente nuevamente.');
    }

    return Promise.reject(error);
  }
);

export default pythonApiClient;
export { pythonApiClient as basePythonApi };
